<template>
    <el-card class="reportsList">
        <div style=" font-size: 16px;
        font-weight: 900;">问题经理</div>
        <ul>
            <router-link :to="{path:'/commitedPro'}">
                <li>受理的二线支持</li>
            </router-link>
            <router-link :to="{path:'/commitedPro',query:{groupType:'eventManager'}}">
                <li>事件经理提交问题数量</li>
            </router-link>
            <router-link :to="{path:'/proManageHandler'}">
                <li>问题经理经手的问题数量</li>
            </router-link>
            <router-link :to="{path:'/problemToChange'}">
                <li>问题转入变更的数量</li>
            </router-link>
            <router-link :to="{path:'/proToChaNproToClose'}">
                <li>问题转变更数+问题直接关闭比例</li>
            </router-link>
        </ul>
    </el-card>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .reportsList{
        /*height: 120px;*/
        background: white;
        font-size: 15px;
    }
    .reportsList div{
        padding-left: 15px;
    }
    .reportsList ul{
        float: left;
        margin: 20px 10px 10px 10px;

    }
    .reportsList ul li{
        color: grey;
        float: left;
        margin: 5px 35px 5px 5px;
    }
</style>
